import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { EmployeePayrollItemContainerComponent, EmployeePayrollItemPresenter } from './employee-payroll-item';
import { EmployeeBaseRatePresenterComponent } from './employee-payroll-item/employee-base-rate-presenter/employee-base-rate-presenter.component';
import { EmployeePayrollItemRoute } from './employee-payroll-item/employee-payroll-item.route';
import { PayrollItemFeatureComponent } from './item/payroll-item-feature/payroll-item-feature.component';
import { PayrollItemRoute } from './item/payroll-item.route';
import { PayrollItemComponent } from './item/payroll-item/payroll-item.component';
import { PayrollItemEmployeeEffects } from './item/store/payroll-item-employee.effects';
import * as fromPayrollItemEmployee from './item/store/payroll-item-employee.reducer';
import { PayrollItemEffects } from './item/store/payroll-item.effects';
import * as fromPayrollItem from './item/store/payroll-item.reducer';
import { PayrollCodesComponent } from './third-party/payroll-codes/payroll-codes.component';
import { PayrollItemAssociationComponent } from './third-party/payroll-item-association/payroll-item-association.component';
import { ThirdPartyPayrollEffects } from './third-party/store/third-party-payroll.effects';
import * as fromThirdPartyPayroll from './third-party/store/third-party-payroll.reducer';
import { ThirdPartyPayrollContainerComponent } from './third-party/third-party-payroll-container/third-party-payroll-container.component';
import { ThirdPartyPayrollExportComponent } from './third-party/third-party-payroll-export/third-party-payroll-export.component';
import { ThirdPartyPayrollFileFormatComponent } from './third-party/third-party-payroll-file-format/third-party-payroll-file-format.component';
import { ThirdPartyPayrollRoute } from './third-party/third-party-payroll.route';
import { EmployeePayrollItemFilterComponent } from './employee-payroll-item/employee-payroll-item-filter/employee-payroll-item-filter.component';
import * as fromEmployeeBaseRate from './employee-payroll-item/store/employee-base-rate.reducer';
import { EmployeeBaseRateEffects } from './employee-payroll-item/store/employee-base-rate.effects';
import { PayrollExportModule } from './payroll-export/payroll-export.module';
import { PayrollExportContainerComponent } from './payroll-export/payroll-export-container';
import { PayrollExportPresenter } from './payroll-export/payroll-export-presenter';

@NgModule({
    declarations: [
        PayrollItemComponent,
        PayrollItemFeatureComponent,
        ThirdPartyPayrollContainerComponent,
        PayrollCodesComponent,
        PayrollItemAssociationComponent,
        ThirdPartyPayrollFileFormatComponent,
        ThirdPartyPayrollExportComponent,
        EmployeePayrollItemContainerComponent,
        EmployeeBaseRatePresenterComponent,
        EmployeePayrollItemPresenter,
        EmployeePayrollItemFilterComponent,
        PayrollExportContainerComponent,
        PayrollExportPresenter
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        PayrollExportModule,
        StoreModule.forFeature(
            fromPayrollItem.payrollItemsFeatureKey,
            fromPayrollItem.reducer
        ),
        StoreModule.forFeature(
            fromPayrollItemEmployee.payrollItemEmployeesFeatureKey,
            fromPayrollItemEmployee.reducer
        ),
        StoreModule.forFeature(
            fromEmployeeBaseRate.employeeBaseRatesFeatureKey,
            fromEmployeeBaseRate.reducer
        ),
        EffectsModule.forFeature([
            PayrollItemEffects,
            PayrollItemEmployeeEffects,
            ThirdPartyPayrollEffects,
            EmployeeBaseRateEffects
        ]),
        UIRouterModule.forChild({
            states: [
                PayrollItemRoute,
                ThirdPartyPayrollRoute,
                EmployeePayrollItemRoute
            ]
        }),
        StoreModule.forFeature(
            fromThirdPartyPayroll.thirdPartyPayrollFeatureKey,
            fromThirdPartyPayroll.reducer
        )
    ]
})
export class PayrollModule {}
